import { render, staticRenderFns } from "./legalMaintenance.vue?vue&type=template&id=c97b7832&scoped=true&"
import script from "./legalMaintenance.vue?vue&type=script&lang=js&"
export * from "./legalMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./legalMaintenance.vue?vue&type=style&index=0&id=c97b7832&prod&scoped=true&lang=css&"
import style1 from "./legalMaintenance.vue?vue&type=style&index=1&id=c97b7832&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97b7832",
  null
  
)

export default component.exports